import { useUser } from "@clerk/clerk-react";
import { checkUser } from "./AuthService";

export const useUserData = () => {
  const { user } = useUser();

  const getUserInfo = async () => {
    if (!user) return null;

    try {
      const email = user.primaryEmailAddress.emailAddress;
      const userData = await checkUser(email);

      if (!userData) return null;

      return {
        accountId: userData.accountId, // Ajout de l'ID du compte
        isAdmin: userData.isAdmin,
        selectedDomain: userData.selectedDomain || null,
      };
    } catch (error) {
      // console.error("Erreur lors de la récupération des infos utilisateur :", error);
      return null;
    }
  };

  return { getUserInfo };
};
